

// import React, { useState, useEffect } from 'react';
// import '../styles/EquipmentRequest.css';

// const EquipmentRequest = ({ userData }) => {
//   const [device, setDevice] = useState("");
//   const [impact, setImpact] = useState("");
//   const [modelNo, setModelNo] = useState("");
//   const [description, setDescription] = useState("");
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [myRequests, setMyRequests] = useState([]);
//   const [allRequests, setAllRequests] = useState([]);
//   const [isSubmitting, setIsSubmitting] = useState(false);


//   const isManagement = userData?.role === "management";


//   // Updated to match your gt-api folder
//   const API_BASE = "/gt-api";

//   const ticketInfo = {
//     ticketNo: "TCKT-2025-AX92",
//     date: new Date().toLocaleDateString('en-GB'),
//     assignedTo: "IT Support Team"
//   };

//   const getEmployeeName = () => {
//     if (userData?.firstName || userData?.lastName) {
//       return `${userData.firstName || ''} ${userData.lastName || ''}`.trim();
//     }
//     return userData?.fullName || "Loading...";
//   };

//   // 1. Fetch History for the logged-in employee
//   const fetchHistory = () => {
//     const empId = userData?.employeeId || "GT-2025-0892";
//     fetch(`${API_BASE}/get_user_requests.php?employee_id=${empId}`)
//       .then(res => res.json())
//       .then(data => {
//         if (data.success) setMyRequests(data.requests);
//       })
//       .catch(err => console.error("Error fetching history:", err));
//   };

//   // 2. Fetch ALL requests for the Management side
//   const fetchAllRequests = () => {
//     fetch(`${API_BASE}/get_all_equip_request.php`)
//       .then(res => res.json())
//       .then(data => {
//         console.log("Management Data Received:", data);
//         if (data.success) {
//           setAllRequests(data.requests);
//         }
//       })
//       .catch(err => console.error("Error fetching management history:", err));
//   };

//   // 3. Clear Notifications
//   const clearNotifications = async () => {
//     const empId = userData?.employeeId || "GT-2025-0892";
//     try {
//       await fetch(`${API_BASE}/clear_notifications.php`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ employee_id: empId }),
//       });
//     } catch (err) {
//       console.error("Failed to clear notifications:", err);
//     }
//   };

//   // useEffect(() => {
//   //   fetchHistory();
//   //   fetchAllRequests();
//   //   clearNotifications();
//   // }, [userData]);



//   useEffect(() => {
//     if (!userData) return;

//     if (isManagement) {
//       fetchAllRequests();
//     } else {
//       fetchHistory();
//       clearNotifications();
//     }
//   }, [userData]);


//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setSelectedImage(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };



//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true); // Add a loading state if you have one

//     try {
//       const formData = new FormData();
//       // Append text data
//       formData.append('employee_id', userData?.employeeId || "GT-2025-0892");
//       formData.append('employee_name', getEmployeeName());
//       formData.append('equipment_type', device);
//       formData.append('reason', description);
//       formData.append('model_no', modelNo);
//       formData.append('impact', impact);

//       // Append the actual file object (if selected)
//       const fileInput = document.getElementById('equip-file-upload');
//       if (fileInput.files[0]) {
//         formData.append('image', fileInput.files[0]);
//       }

//       const response = await fetch(`${API_BASE}/submit_equipment_request.php`, {
//         method: "POST",
//         // Note: Do NOT set Content-Type header when sending FormData; 
//         // the browser will set it automatically with the correct boundary.
//         body: formData,
//       });

//       const data = await response.json();
//       if (data.success) {
//         alert(`Ticket submitted successfully!`);
//         // Reset form
//         setDevice(""); setDescription(""); setModelNo(""); setImpact(""); setSelectedImage(null);
//         fileInput.value = ""; // Clear the file input

//         // Refresh both lists
//         fetchHistory();
//         fetchAllRequests();
//       } else {
//         alert("Submission failed: " + data.message);
//       }
//     } catch (error) {
//       console.error("Submission Error:", error);
//       alert("Server error. Please check if the API is running.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };



//   const handleStatusUpdate = async (id, newStatus) => {
//     if (!window.confirm(`Are you sure you want to mark this as ${newStatus}?`)) return;

//     try {
//       const response = await fetch(`${API_BASE}/update_request_status.php`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ id, status: newStatus }),
//       });
//       const data = await response.json();
//       if (data.success) {
//         // Re-fetch all to move the item from 'Pending Queue' to 'Completed History'
//         fetchAllRequests();
//         fetchHistory();
//       }
//     } catch (err) {
//       console.error("Update error:", err);
//     }
//   };

//   return (
//     <div className="equipment-request-wrapper animate-fade">
//       <div className="request-card glass">
//         <div className="form-header-main">
//           <div className="header-icon">⚙️</div>
//           <div className="header-titles">
//             <h2>EQUIPMENT_CHECK_REQUEST</h2>
//             {/* <p>Node: Terminal_{ticketInfo.ticketNo}</p> */}
//           </div>
//         </div>

//         {/* --- ORIGINAL FORM SECTION --- */}
//         <form className="cyber-form-layout" onSubmit={handleSubmit}>
//           <div className="form-sub-label">IDENTIFICATION_METADATA</div>
//           <div className="readonly-grid">
//             <div className="form-group">
//               <label>TICKET NUMBER</label>
//               <input type="text" value={ticketInfo.ticketNo} readOnly className="read-only-input" />
//             </div>
//             <div className="form-group">
//               <label>REQUEST DATE</label>
//               <input type="text" value={ticketInfo.date} readOnly className="read-only-input" />
//             </div>
//             <div className="form-group">
//               <label>EMPLOYEE NAME</label>
//               <input type="text" value={getEmployeeName()} readOnly className="read-only-input" />
//             </div>
//             <div className="form-group">
//               <label>EMAIL ADDRESS</label>
//               <input type="text" value={userData?.email || "Loading..."} readOnly className="read-only-input" />
//             </div>
//           </div>

//           <div className="cyber-divider"></div>

//           <div className="form-sub-label">DEVICE_SPECIFICATIONS</div>
//           <div className="editable-grid">
//             <div className="form-group">
//               <label>SELECT DEVICE</label>
//               <div className="ui-select-container">
//                 <select value={device} onChange={(e) => setDevice(e.target.value)} className="theme-select-field" required>
//                   <option value="" disabled hidden>Select hardware...</option>
//                   <option value="Mouse">Optical Mouse</option>
//                   <option value="Keyboard">Mechanical Keyboard</option>
//                   <option value="Monitor">External Monitor</option>
//                   <option value="Laptop">Primary Workstation</option>
//                   <option value="Headphones">Noise-Canceling Headphones</option>
//                 </select>
//                 <span className="select-arrow">▼</span>
//               </div>
//             </div>

//             <div className="form-group">
//               <label>MODEL NUMBER</label>
//               <input type="text" className="theme-text-input" value={modelNo} onChange={(e) => setModelNo(e.target.value)} />
//             </div>

//             <div className="form-group full-row">
//               <label>DESCRIPTION OF ISSUE</label>
//               <textarea className="theme-textarea" value={description} onChange={(e) => setDescription(e.target.value)} required />
//             </div>

//             <div className="form-group">
//               <label>IMPACT OF WORK</label>
//               <div className="ui-select-container">
//                 <select value={impact} onChange={(e) => setImpact(e.target.value)} className="theme-select-field" required>
//                   <option value="" disabled hidden>Choose urgency...</option>
//                   <option value="minor">Minor</option>
//                   <option value="major">Major</option>
//                   <option value="blocking">Blocking</option>
//                 </select>
//                 <span className="select-arrow">▼</span>
//               </div>
//             </div>

//             <div className="form-group full-row">
//               <label>ATTACHMENT (IMAGE)</label>
//               <div className="upload-container">
//                 <input type="file" id="equip-file-upload" className="hidden-input" accept="image/*" onChange={handleImageChange} />
//                 <label htmlFor="equip-file-upload" className="upload-trigger-zone">
//                   {selectedImage ? (
//                     <div className="preview-area">
//                       <img src={selectedImage} alt="Preview" className="img-preview" />
//                       <span>Change Photo</span>
//                     </div>
//                   ) : (
//                     <div className="upload-prompt">
//                       <span className="upload-icon">📸</span>
//                       <p>Click here to upload device photo</p>
//                       <small>(JPG, PNG or WEBP)</small>
//                     </div>
//                   )}
//                 </label>
//               </div>
//             </div>
//           </div>

//           <div className="form-footer-actions">
//             {/* <button type="submit" className="btn-submit-cyber">GENERATE TICKET</button> */}
//             <button
//               type="submit"
//               className="btn-submit-cyber"
//               disabled={isSubmitting}
//             >
//               {isSubmitting ? "PROCESSING..." : "GENERATE TICKET"}
//             </button>
//             <button type="button" className="btn-abort-cyber" onClick={() => {
//               setDevice(""); setDescription(""); setModelNo(""); setImpact(""); setSelectedImage(null);
//             }}>CLEAR</button>
//           </div>
//         </form>

//         {/* --- STATUS TRACKER (Employee View) --- */}
//         <div className="request-history-section">
//           {/* <div className="cyber-divider"></div> */}
//           {/* <div className="form-sub-label">YOUR_REQUEST_STATUS_TRACKER</div> */}
//           <div className="history-list">
//             {myRequests.map(req => (
//               <div key={req.id} className="history-item glass">
//                 <div className="history-info">
//                   <strong>{req.equipment_type}</strong>
//                   <span>Model: {req.model_no || 'N/A'}</span>
//                   <small>{new Date(req.updated_at).toLocaleDateString()}</small>
//                 </div>
//                 <div className={`status-badge badge-${req.status.toLowerCase()}`}>
//                   {req.status === 'Approved' ? '✅ ' : req.status === 'Rejected' ? '❌ ' : '⏳ '}
//                   {req.status.toUpperCase()}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>


//         {/* --- MANAGEMENT VIEW: COMPLETED HISTORY --- */}
//         {/* <div className="management-history-history-section" style={{ marginTop: '50px' }}>
//           <div className="cyber-divider"></div>
//           <div className="form-sub-label" style={{ color: '#888' }}>COMPLETED_HISTORY</div>
//           <div className="admin-table-container">
//             <table className="cyber-table">
//               <thead>
//                 <tr>
//                   <th>EMPLOYEE</th>
//                   <th>HARDWARE</th>
//                   <th>DATE</th>
//                   <th>STATUS</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {allRequests.filter(r => r.status?.toLowerCase() !== 'pending').length > 0 ? (
//                   allRequests.filter(r => r.status?.toLowerCase() !== 'pending').map((req) => (
//                     <tr key={req.id}>
//                       <td>{req.employee_name}</td>
//                       <td>{req.equipment_type}</td>
//                       <td>{new Date(req.updated_at || req.created_at).toLocaleDateString('en-GB')}</td>
//                       <td>{req.status.toUpperCase()}</td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr><td colSpan="4" style={{ textAlign: 'center' }}>NO_HISTORY_FOUND</td></tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div> */}

//         {isManagement && (
//           <div className="management-history-history-section" style={{ marginTop: '50px' }}>
//             <div className="cyber-divider"></div>
//             <div className="form-sub-label" style={{ color: '#888' }}>
//               HISTORY
//             </div>

//             <div className="admin-table-container">
//               <table className="cyber-table">
//                 <thead>
//                   <tr>
//                     <th>EMPLOYEE</th>
//                     <th>HARDWARE</th>
//                     <th>DATE</th>
//                     <th>STATUS</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {allRequests.filter(r => r.status?.toLowerCase() !== 'pending').length > 0 ? (
//                     allRequests
//                       .filter(r => r.status?.toLowerCase() !== 'pending')
//                       .map(req => (
//                         <tr key={req.id}>
//                           <td>{req.employee_name}</td>
//                           <td>{req.equipment_type}</td>
//                           <td>{new Date(req.updated_at || req.created_at).toLocaleDateString('en-GB')}</td>
//                           <td>{req.status.toUpperCase()}</td>
//                         </tr>
//                       ))
//                   ) : (
//                     <tr>
//                       <td colSpan="4" style={{ textAlign: 'center' }}>
//                         NO_HISTORY_FOUND
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}




//       </div>
//     </div>
//   );
// };

// export default EquipmentRequest;












// import React, { useState, useEffect } from 'react';
// import '../styles/EquipmentRequest.css';

// const EquipmentRequest = ({ userData }) => {
//   const [device, setDevice] = useState("");
//   const [impact, setImpact] = useState("");
//   const [modelNo, setModelNo] = useState("");
//   const [description, setDescription] = useState("");
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [myRequests, setMyRequests] = useState([]);
//   const [allRequests, setAllRequests] = useState([]);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const isManagement = userData?.role === "management";
//   const API_BASE = "/gt-api";

//   // NEW: Updated Device List
//   const deviceOptions = [
//     "Keyboard",
//     "Mouse",
//     "Monitor",
//     "Headset",
//     "Docking Station",
//     "USB Cable",
//     "Camera",
//     "HDMI Cable",
//     "Laptop"
//   ];

//   const ticketInfo = {
//     ticketNo: "TCKT-2025-AX92",
//     date: new Date().toLocaleDateString('en-GB'),
//     assignedTo: "IT Support Team"
//   };

//   const getEmployeeName = () => {
//     if (userData?.firstName || userData?.lastName) {
//       return `${userData.firstName || ''} ${userData.lastName || ''}`.trim();
//     }
//     return userData?.fullName || "Loading...";
//   };

//   const fetchHistory = () => {
//     const empId = userData?.employeeId || "GT-2025-0892";
//     fetch(`${API_BASE}/get_user_requests.php?employee_id=${empId}`)
//       .then(res => res.json())
//       .then(data => {
//         if (data.success) setMyRequests(data.requests);
//       })
//       .catch(err => console.error("Error fetching history:", err));
//   };

//   const fetchAllRequests = () => {
//     fetch(`${API_BASE}/get_all_equip_request.php`)
//       .then(res => res.json())
//       .then(data => {
//         if (data.success) setAllRequests(data.requests);
//       })
//       .catch(err => console.error("Error fetching management history:", err));
//   };

//   const clearNotifications = async () => {
//     const empId = userData?.employeeId || "GT-2025-0892";
//     try {
//       await fetch(`${API_BASE}/clear_notifications.php`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ employee_id: empId }),
//       });
//     } catch (err) {
//       console.error("Failed to clear notifications:", err);
//     }
//   };

//   useEffect(() => {
//     if (!userData) return;
//     if (isManagement) {
//       fetchAllRequests();
//     } else {
//       fetchHistory();
//       clearNotifications();
//     }
//   }, [userData]);

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => setSelectedImage(reader.result);
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);
//     try {
//       const formData = new FormData();
//       formData.append('employee_id', userData?.employeeId || "GT-2025-0892");
//       formData.append('employee_name', getEmployeeName());
//       formData.append('equipment_type', device);
//       formData.append('reason', description);
//       formData.append('model_no', modelNo);
//       formData.append('impact', impact);

//       const fileInput = document.getElementById('equip-file-upload');
//       if (fileInput.files[0]) {
//         formData.append('image', fileInput.files[0]);
//       }

//       const response = await fetch(`${API_BASE}/submit_equipment_request.php`, {
//         method: "POST",
//         body: formData,
//       });

//       const data = await response.json();
//       if (data.success) {
//         alert(`Ticket submitted successfully!`);
//         setDevice(""); setDescription(""); setModelNo(""); setImpact(""); setSelectedImage(null);
//         fileInput.value = "";
//         fetchHistory();
//         fetchAllRequests();
//       } else {
//         alert("Submission failed: " + data.message);
//       }
//     } catch (error) {
//       alert("Server error. Please check if the API is running.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div className="equipment-request-wrapper animate-fade">
//       <div className="request-card glass">
//         <div className="form-header-main">
//           <div className="header-icon">⚙️</div>
//           <div className="header-titles">
//             <h2>EQUIPMENT_CHECK_REQUEST</h2>
//           </div>
//         </div>

//         <form className="cyber-form-layout" onSubmit={handleSubmit}>
//           <div className="form-sub-label">IDENTIFICATION_METADATA</div>
//           <div className="readonly-grid">
//             <div className="form-group">
//               <label>TICKET NUMBER</label>
//               <input type="text" value={ticketInfo.ticketNo} readOnly className="read-only-input" />
//             </div>
//             <div className="form-group">
//               <label>REQUEST DATE</label>
//               <input type="text" value={ticketInfo.date} readOnly className="read-only-input" />
//             </div>
//             <div className="form-group">
//               <label>EMPLOYEE NAME</label>
//               <input type="text" value={getEmployeeName()} readOnly className="read-only-input" />
//             </div>
//             <div className="form-group">
//               <label>EMAIL ADDRESS</label>
//               <input type="text" value={userData?.email || "Loading..."} readOnly className="read-only-input" />
//             </div>
//           </div>

//           <div className="cyber-divider"></div>

//           <div className="form-sub-label">DEVICE_SPECIFICATIONS</div>
//           <div className="editable-grid">
//             <div className="form-group">
//               <label>SELECT DEVICE</label>
//               <div className="ui-select-container">
//                 <select 
//                   value={device} 
//                   onChange={(e) => setDevice(e.target.value)} 
//                   className="theme-select-field" 
//                   required
//                 >
//                   <option value="" disabled hidden>Select hardware...</option>
//                   {/* Map through the new list */}
//                   {deviceOptions.map((opt) => (
//                     <option key={opt} value={opt}>{opt}</option>
//                   ))}
//                 </select>
//                 <span className="select-arrow">▼</span>
//               </div>
//             </div>

//             <div className="form-group">
//               <label>MODEL NUMBER</label>
//               <input type="text" className="theme-text-input" value={modelNo} onChange={(e) => setModelNo(e.target.value)} />
//             </div>

//             <div className="form-group full-row">
//               <label>DESCRIPTION OF ISSUE</label>
//               <textarea className="theme-textarea" value={description} onChange={(e) => setDescription(e.target.value)} required />
//             </div>

//             <div className="form-group">
//               <label>IMPACT OF WORK</label>
//               <div className="ui-select-container">
//                 <select value={impact} onChange={(e) => setImpact(e.target.value)} className="theme-select-field" required>
//                   <option value="" disabled hidden>Choose urgency...</option>
//                   <option value="minor">Minor</option>
//                   <option value="major">Major</option>
//                   <option value="blocking">Blocking</option>
//                 </select>
//                 <span className="select-arrow">▼</span>
//               </div>
//             </div>


//           </div>

//           <div className="form-footer-actions">
//             <button type="submit" className="btn-submit-cyber" disabled={isSubmitting}>
//               {isSubmitting ? "PROCESSING..." : "GENERATE TICKET"}
//             </button>
//             <button type="button" className="btn-abort-cyber" onClick={() => {
//               setDevice(""); setDescription(""); setModelNo(""); setImpact(""); setSelectedImage(null);
//             }}>CLEAR</button>
//           </div>
//         </form>

//         <div className="request-history-section">
//           <div className="history-list">
//             {myRequests.map(req => (
//               <div key={req.id} className="history-item glass">
//                 <div className="history-info">
//                   <strong>{req.equipment_type}</strong>
//                   <span>Model: {req.model_no || 'N/A'}</span>
//                   <small>{new Date(req.updated_at).toLocaleDateString()}</small>
//                 </div>
//                 <div className={`status-badge badge-${req.status.toLowerCase()}`}>
//                   {req.status === 'Approved' ? '✅ ' : req.status === 'Rejected' ? '❌ ' : '⏳ '}
//                   {req.status.toUpperCase()}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {isManagement && (
//           <div className="management-history-history-section" style={{ marginTop: '50px' }}>
//             <div className="cyber-divider"></div>
//             <div className="form-sub-label" style={{ color: '#888' }}>HISTORY</div>
//             <div className="admin-table-container">
//               <table className="cyber-table">
//                 <thead>
//                   <tr>
//                     <th>EMPLOYEE</th>
//                     <th>HARDWARE</th>
//                     <th>DATE</th>
//                     <th>STATUS</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {allRequests.filter(r => r.status?.toLowerCase() !== 'pending').map(req => (
//                     <tr key={req.id}>
//                       <td>{req.employee_name}</td>
//                       <td>{req.equipment_type}</td>
//                       <td>{new Date(req.updated_at || req.created_at).toLocaleDateString('en-GB')}</td>
//                       <td>{req.status.toUpperCase()}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default EquipmentRequest;












// import React, { useState, useEffect } from 'react';
// import '../styles/EquipmentRequest.css';

// const EquipmentRequest = ({ userData }) => {
//   const [device, setDevice] = useState("");
//   const [impact, setImpact] = useState("");
//   const [modelNo, setModelNo] = useState("");
//   const [description, setDescription] = useState("");
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [myRequests, setMyRequests] = useState([]);
//   const [allRequests, setAllRequests] = useState([]);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const isManagement = userData?.role === "management";
//   const API_BASE = "/gt-api";

//   const deviceOptions = [
//     "Keyboard","Mouse","Monitor","Headset","Docking Station","USB Cable","Camera","HDMI Cable","Laptop"
//   ];

//   const ticketInfo = {
//     ticketNo: "TCKT-2025-AX92",
//     date: new Date().toLocaleDateString('en-GB'),
//     assignedTo: "IT Support Team"
//   };

//   const getEmployeeName = () => {
//     if (userData?.firstName || userData?.lastName) {
//       return `${userData.firstName || ''} ${userData.lastName || ''}`.trim();
//     }
//     return userData?.fullName || "Loading...";
//   };

//   const fetchHistory = () => {
//     const empId = userData?.employeeId || "GT-2025-0892";
//     fetch(`${API_BASE}/get_user_requests.php?employee_id=${empId}`)
//       .then(res => res.json())
//       .then(data => { if (data.success) setMyRequests(data.requests); })
//       .catch(err => console.error("Error fetching history:", err));
//   };

//   const fetchAllRequests = () => {
//     fetch(`${API_BASE}/get_all_equip_request.php`)
//       .then(res => res.json())
//       .then(data => { if (data.success) setAllRequests(data.requests); })
//       .catch(err => console.error("Error fetching management history:", err));
//   };

//   const clearNotifications = async () => {
//     const empId = userData?.employeeId || "GT-2025-0892";
//     try {
//       await fetch(`${API_BASE}/clear_notifications.php`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ employee_id: empId }),
//       });
//     } catch (err) { console.error("Failed to clear notifications:", err); }
//   };

//   useEffect(() => {
//     if (!userData) return;
//     if (isManagement) fetchAllRequests();
//     else { fetchHistory(); clearNotifications(); }
//   }, [userData]);

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => setSelectedImage(reader.result);
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);
//     try {
//       const formData = new FormData();
//       formData.append('employee_id', userData?.employeeId || "GT-2025-0892");
//       formData.append('employee_name', getEmployeeName());
//       formData.append('equipment_type', device);
//       formData.append('reason', description);
//       formData.append('model_no', modelNo);
//       formData.append('impact', impact);

//       const fileInput = document.getElementById('equip-file-upload');
//       if (fileInput?.files[0]) formData.append('image', fileInput.files[0]);

//       const response = await fetch(`${API_BASE}/submit_equipment_request.php`, {
//         method: "POST",
//         body: formData,
//       });

//       // Read raw text first to avoid JSON parse errors
//       const text = await response.text();
//       console.log("Raw response from PHP:", text);

//       let data;
//       try { data = JSON.parse(text); }
//       catch(err) { throw new Error("Invalid JSON response from server"); }

//       if (data.success) {
//         alert(`Ticket submitted successfully!`);
//         setDevice(""); setDescription(""); setModelNo(""); setImpact(""); setSelectedImage(null);
//         if (fileInput) fileInput.value = "";
//         fetchHistory();
//         fetchAllRequests();
//       } else {
//         alert("Submission failed: " + data.message);
//       }
//     } catch (error) {
//       console.error("Error submitting ticket:", error);
//       alert("Server error. Please check console for details.");
//     } finally { setIsSubmitting(false); }
//   };

//   return (
//     <div className="equipment-request-wrapper animate-fade">
//       <div className="request-card glass">
//         <div className="form-header-main">
//           <div className="header-icon">⚙️</div>
//           <div className="header-titles"><h2>EQUIPMENT_CHECK_REQUEST</h2></div>
//         </div>

//         <form className="cyber-form-layout" onSubmit={handleSubmit}>
//           <div className="form-sub-label">IDENTIFICATION_METADATA</div>
//           <div className="readonly-grid">
//             <div className="form-group"><label>TICKET NUMBER</label><input type="text" value={ticketInfo.ticketNo} readOnly className="read-only-input" /></div>
//             <div className="form-group"><label>REQUEST DATE</label><input type="text" value={ticketInfo.date} readOnly className="read-only-input" /></div>
//             <div className="form-group"><label>EMPLOYEE NAME</label><input type="text" value={getEmployeeName()} readOnly className="read-only-input" /></div>
//             <div className="form-group"><label>EMAIL ADDRESS</label><input type="text" value={userData?.email || "Loading..."} readOnly className="read-only-input" /></div>
//           </div>

//           <div className="cyber-divider"></div>
//           <div className="form-sub-label">DEVICE_SPECIFICATIONS</div>
//           <div className="editable-grid">
//             <div className="form-group">
//               <label>SELECT DEVICE</label>
//               <div className="ui-select-container">
//                 <select value={device} onChange={(e)=>setDevice(e.target.value)} className="theme-select-field" required>
//                   <option value="" disabled hidden>Select hardware...</option>
//                   {deviceOptions.map(opt=><option key={opt} value={opt}>{opt}</option>)}
//                 </select>
//                 <span className="select-arrow">▼</span>
//               </div>
//             </div>
//             <div className="form-group"><label>MODEL NUMBER</label><input type="text" className="theme-text-input" value={modelNo} onChange={(e)=>setModelNo(e.target.value)} /></div>
//             <div className="form-group full-row"><label>DESCRIPTION OF ISSUE</label><textarea className="theme-textarea" value={description} onChange={(e)=>setDescription(e.target.value)} required /></div>
//             <div className="form-group">
//               <label>IMPACT OF WORK</label>
//               <div className="ui-select-container">
//                 <select value={impact} onChange={(e)=>setImpact(e.target.value)} className="theme-select-field" required>
//                   <option value="" disabled hidden>Choose urgency...</option>
//                   <option value="minor">Minor</option>
//                   <option value="major">Major</option>
//                   <option value="blocking">Blocking</option>
//                 </select>
//                 <span className="select-arrow">▼</span>
//               </div>
//             </div>
//           </div>

//           <div className="form-footer-actions">
//             <button type="submit" className="btn-submit-cyber" disabled={isSubmitting}>
//               {isSubmitting ? "PROCESSING..." : "GENERATE TICKET"}
//             </button>
//             <button type="button" className="btn-abort-cyber" onClick={()=>{setDevice(""); setDescription(""); setModelNo(""); setImpact(""); setSelectedImage(null);}}>CLEAR</button>
//           </div>
//         </form>

//         <div className="request-history-section">
//           <div className="history-list">
//             {myRequests.map(req=>(
//               <div key={req.id} className="history-item glass">
//                 <div className="history-info">
//                   <strong>{req.equipment_type}</strong>
//                   <span>Model: {req.model_no || 'N/A'}</span>
//                   <small>{new Date(req.updated_at).toLocaleDateString()}</small>
//                 </div>
//                 <div className={`status-badge badge-${req.status.toLowerCase()}`}>
//                   {req.status==='Approved'?'✅ ':req.status==='Rejected'?'❌ ':'⏳ '}
//                   {req.status.toUpperCase()}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {isManagement && (
//           <div className="management-history-history-section" style={{marginTop:'50px'}}>
//             <div className="cyber-divider"></div>
//             <div className="form-sub-label" style={{color:'#888'}}>HISTORY</div>
//             <div className="admin-table-container">
//               <table className="cyber-table">
//                 <thead>
//                   <tr><th>EMPLOYEE</th><th>HARDWARE</th><th>DATE</th><th>STATUS</th></tr>
//                 </thead>
//                 <tbody>
//                   {allRequests.filter(r=>r.status?.toLowerCase()!=='pending').map(req=>(
//                     <tr key={req.id}>
//                       <td>{req.employee_name}</td>
//                       <td>{req.equipment_type}</td>
//                       <td>{new Date(req.updated_at||req.created_at).toLocaleDateString('en-GB')}</td>
//                       <td>{req.status.toUpperCase()}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default EquipmentRequest;















// import React, { useState, useEffect } from 'react';
// import '../styles/EquipmentRequest.css';

// const EquipmentRequest = ({ userData }) => {
//   const [device, setDevice] = useState("");
//   const [impact, setImpact] = useState("");
//   const [modelNo, setModelNo] = useState("");
//   const [description, setDescription] = useState("");
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [myRequests, setMyRequests] = useState([]);
//   const [allRequests, setAllRequests] = useState([]);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const isManagement = userData?.role === "management";
//   const API_BASE = "/gt-api";

//   const deviceOptions = [
//     "Keyboard","Mouse","Monitor","Headset","Docking Station","USB Cable","Camera","HDMI Cable","Laptop"
//   ];

//   const ticketInfo = {
//     ticketNo: "TCKT-2025-AX92",
//     date: new Date().toLocaleDateString('en-GB'),
//     assignedTo: "IT Support Team"
//   };

//   const getEmployeeName = () => {
//     if (userData?.firstName || userData?.lastName) {
//       return `${userData.firstName || ''} ${userData.lastName || ''}`.trim();
//     }
//     return userData?.fullName || "Loading...";
//   };

//   const fetchHistory = () => {
//     const empId = userData?.employeeId || "GT-2025-0892";
//     fetch(`${API_BASE}/get_user_requests.php?employee_id=${empId}`)
//       .then(res => res.json())
//       .then(data => { if (data.success) setMyRequests(data.requests); })
//       .catch(err => console.error("Error fetching history:", err));
//   };

//   const fetchAllRequests = () => {
//     fetch(`${API_BASE}/get_all_equip_request.php`)
//       .then(res => res.json())
//       .then(data => { if (data.success) setAllRequests(data.requests); })
//       .catch(err => console.error("Error fetching management history:", err));
//   };

//   const clearNotifications = async () => {
//     const empId = userData?.employeeId || "GT-2025-0892";
//     try {
//       await fetch(`${API_BASE}/clear_notifications.php`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ employee_id: empId }),
//       });
//     } catch (err) { console.error("Failed to clear notifications:", err); }
//   };

//   useEffect(() => {
//     if (!userData) return;
//     if (isManagement) fetchAllRequests();
//     else { fetchHistory(); clearNotifications(); }
//   }, [userData]);

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => setSelectedImage(reader.result);
//       reader.readAsDataURL(file);
//     }
//   };
// const handleSubmit = async (e) => {
//   e.preventDefault();
//   setIsSubmitting(true);

//   try {
//     const formData = new FormData();

//     formData.append(
//       'employee_id',
//       userData?.employeeId || "GT-2025-0892"
//     );
//     formData.append(
//       'employee_name',
//       getEmployeeName()
//     );
//     formData.append(
//       'equipment_type',
//       device
//     );
//     formData.append(
//       'reason',
//       description
//     );
//     formData.append(
//       'model_no',
//       modelNo
//     );
//     formData.append(
//       'impact',
//       impact
//     );

//     const fileInput = document.getElementById('equip-file-upload');

//     if (fileInput?.files[0]) {
//       formData.append('image', fileInput.files[0]);
//     }

//     const response = await fetch(
//       `${API_BASE}/submit_equipment_request.php`,
//       {
//         method: "POST",
//         body: formData,
//       }
//     );

//     const text = await response.text();
//     console.log("Raw response from PHP:", text);

//     let data;

//     try {
//       data = JSON.parse(text);
//     } catch (err) {
//       throw new Error("Invalid JSON response from server");
//     }

//     if (data.success) {
//       alert(`Ticket submitted successfully!`);

//       setDevice("");
//       setDescription("");
//       setModelNo("");
//       setImpact("");
//       setSelectedImage(null);

//       if (fileInput) {
//         fileInput.value = "";
//       }

//       // Refresh employee's history immediately
//       fetchHistory();

//       // Refresh management table if applicable
//       if (isManagement) {
//         fetchAllRequests();
//       }

//     } else {
//       alert("Submission failed: " + data.message);
//     }

//   } catch (error) {
//     console.error("Error submitting ticket:", error);
//     alert("Server error. Please check console for details.");
//   } finally {
//     setIsSubmitting(false);
//   }
// };
//   return (
//     <div className="equipment-request-wrapper animate-fade">
//       <div className="request-card glass">
//         <div className="form-header-main">
//           <div className="header-icon">⚙️</div>
//           <div className="header-titles"><h2>EQUIPMENT_CHECK_REQUEST</h2></div>
//         </div>

//         <form className="cyber-form-layout" onSubmit={handleSubmit}>
//           <div className="form-sub-label">IDENTIFICATION_METADATA</div>
//           <div className="readonly-grid">
//             <div className="form-group"><label>TICKET NUMBER</label><input type="text" value={ticketInfo.ticketNo} readOnly className="read-only-input" /></div>
//             <div className="form-group"><label>REQUEST DATE</label><input type="text" value={ticketInfo.date} readOnly className="read-only-input" /></div>
//             <div className="form-group"><label>EMPLOYEE NAME</label><input type="text" value={getEmployeeName()} readOnly className="read-only-input" /></div>
//             <div className="form-group"><label>EMAIL ADDRESS</label><input type="text" value={userData?.email || "Loading..."} readOnly className="read-only-input" /></div>
//           </div>

//           <div className="cyber-divider"></div>
//           <div className="form-sub-label">DEVICE_SPECIFICATIONS</div>
//           <div className="editable-grid">
//             <div className="form-group">
//               <label>SELECT DEVICE</label>
//               <div className="ui-select-container">
//                 <select value={device} onChange={(e)=>setDevice(e.target.value)} className="theme-select-field" required>
//                   <option value="" disabled hidden>Select hardware...</option>
//                   {deviceOptions.map(opt=><option key={opt} value={opt}>{opt}</option>)}
//                 </select>
//                 <span className="select-arrow">▼</span>
//               </div>
//             </div>
//             <div className="form-group"><label>MODEL NUMBER</label><input type="text" className="theme-text-input" value={modelNo} onChange={(e)=>setModelNo(e.target.value)} /></div>
//             <div className="form-group full-row"><label>DESCRIPTION OF ISSUE</label><textarea className="theme-textarea" value={description} onChange={(e)=>setDescription(e.target.value)} required /></div>
//             <div className="form-group">
//               <label>IMPACT OF WORK</label>
//               <div className="ui-select-container">
//                 <select value={impact} onChange={(e)=>setImpact(e.target.value)} className="theme-select-field" required>
//                   <option value="" disabled hidden>Choose urgency...</option>
//                   <option value="minor">Minor</option>
//                   <option value="major">Major</option>
//                   <option value="blocking">Blocking</option>
//                 </select>
//                 <span className="select-arrow">▼</span>
//               </div>
//             </div>
//           </div>

//           <div className="form-footer-actions">
//             <button type="submit" className="btn-submit-cyber" disabled={isSubmitting}>
//               {isSubmitting ? "PROCESSING..." : "GENERATE TICKET"}
//             </button>
//             <button type="button" className="btn-abort-cyber" onClick={()=>{setDevice(""); setDescription(""); setModelNo(""); setImpact(""); setSelectedImage(null);}}>CLEAR</button>
//           </div>
//         </form>

//         {/* Employee's own request history */}
//         <div className="request-history-section">
//           <div className="history-list">
//             {myRequests.map(req => (
//               <div key={req.id} className="history-item glass">
//                 <div className="history-info">
//                   <strong>{req.equipment_type}</strong>
//                   <span>Model: {req.model_no || 'N/A'}</span>
//                   <small>{new Date(req.updated_at).toLocaleDateString()}</small>
//                 </div>
//                 <div className={`status-badge badge-${req.status.toLowerCase()}`}>
//                   {req.status==='Approved'?' ':req.status==='Rejected'?' ':' '}
//                   {req.status.toUpperCase()}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>




//         {/* Management view */}
//         {isManagement && (
//           <div className="management-history-history-section" style={{marginTop:'50px'}}>
//             <div className="cyber-divider"></div>
//             <div className="form-sub-label" style={{color:'#888'}}>HISTORY</div>
//             <div className="admin-table-container">
//               <table className="cyber-table">
//                 <thead>
//                   <tr><th>EMPLOYEE</th><th>HARDWARE</th><th>DATE</th><th>STATUS</th></tr>
//                 </thead>
//                 <tbody>
//                   {allRequests.filter(r=>r.status?.toLowerCase()!=='pending').map(req => (
//                     <tr key={req.id}>
//                       <td>{req.employee_name}</td>
//                       <td>{req.equipment_type}</td>
//                       <td>{new Date(req.updated_at||req.created_at).toLocaleDateString('en-GB')}</td>
//                       <td>{req.status.toUpperCase()}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default EquipmentRequest;


















// import React, { useState, useEffect } from 'react';
// import '../styles/EquipmentRequest.css';

// const EquipmentRequest = ({ userData }) => {
//   const [device, setDevice] = useState("");
//   const [impact, setImpact] = useState("");
//   const [modelNo, setModelNo] = useState("");
//   const [description, setDescription] = useState("");
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [myRequests, setMyRequests] = useState([]);
//   const [allRequests, setAllRequests] = useState([]);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const isManagement = userData?.role === "management";
//   const API_BASE = "/gt-api";

//   const deviceOptions = [
//     "Keyboard","Mouse","Monitor","Headset","Docking Station","USB Cable","Camera","HDMI Cable","Laptop"
//   ];

//   const ticketInfo = {
//     ticketNo: "TCKT-2025-AX92",
//     date: new Date().toLocaleDateString('en-GB'),
//     assignedTo: "IT Support Team"
//   };

//   const getEmployeeName = () => {
//     if (userData?.firstName || userData?.lastName) {
//       return `${userData.firstName || ''} ${userData.lastName || ''}`.trim();
//     }
//     return userData?.fullName || "Loading...";
//   };

// const fetchHistory = () => {
//   const empId = userData?.id;

//   fetch(`${API_BASE}/get_user_requests.php?employee_id=${empId}`)
//     .then(res => res.json())
//     .then(data => {
//       if (data.success) setMyRequests(data.requests);
//     })
//     .catch(err => console.error("Error fetching history:", err));
// };

//   const fetchAllRequests = () => {
//     fetch(`${API_BASE}/get_all_equip_request.php`)
//       .then(res => res.json())
//       .then(data => { if (data.success) setAllRequests(data.requests); })
//       .catch(err => console.error("Error fetching management history:", err));
//   };

// const clearNotifications = async () => {
//   const empId = userData?.id;

//   try {
//     await fetch(`${API_BASE}/clear_notifications.php`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ employee_id: empId }),
//     });

//   } catch (err) {
//     console.error("Failed to clear notifications:", err);
//   }
// };
//   useEffect(() => {
//     if (!userData) return;
//     if (isManagement) fetchAllRequests();
//     else { fetchHistory(); clearNotifications(); }
//   }, [userData]);

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => setSelectedImage(reader.result);
//       reader.readAsDataURL(file);
//     }
//   };
// const handleSubmit = async (e) => {
//   e.preventDefault();
//   setIsSubmitting(true);

//   try {
//     const formData = new FormData();

//   formData.append(
//   'employee_id',
//   userData?.id
// );
//     formData.append(
//       'employee_name',
//       getEmployeeName()
//     );
//     formData.append(
//       'equipment_type',
//       device
//     );
//     formData.append(
//       'reason',
//       description
//     );
//     formData.append(
//       'model_no',
//       modelNo
//     );
//     formData.append(
//       'impact',
//       impact
//     );

//     const fileInput = document.getElementById('equip-file-upload');

//     if (fileInput?.files[0]) {
//       formData.append('image', fileInput.files[0]);
//     }

//     const response = await fetch(
//       `${API_BASE}/submit_equipment_request.php`,
//       {
//         method: "POST",
//         body: formData,
//       }
//     );

//     const text = await response.text();
//     console.log("Raw response from PHP:", text);

//     let data;

//     try {
//       data = JSON.parse(text);
//     } catch (err) {
//       throw new Error("Invalid JSON response from server");
//     }

//     if (data.success) {
//       alert(`Ticket submitted successfully!`);

//       setDevice("");
//       setDescription("");
//       setModelNo("");
//       setImpact("");
//       setSelectedImage(null);

//       if (fileInput) {
//         fileInput.value = "";
//       }

//       // Refresh employee's history immediately
//       fetchHistory();

//       // Refresh management table if applicable
//       if (isManagement) {
//         fetchAllRequests();
//       }

//     } else {
//       alert("Submission failed: " + data.message);
//     }

//   } catch (error) {
//     console.error("Error submitting ticket:", error);
//     alert("Server error. Please check console for details.");
//   } finally {
//     setIsSubmitting(false);
//   }
// };
//   return (
//     <div className="equipment-request-wrapper animate-fade">
//       <div className="request-card glass">
//         <div className="form-header-main">
//           <div className="header-icon">⚙️</div>
//           <div className="header-titles"><h2>EQUIPMENT_CHECK_REQUEST</h2></div>
//         </div>

//         <form className="cyber-form-layout" onSubmit={handleSubmit}>
//           <div className="form-sub-label">IDENTIFICATION_METADATA</div>
//           <div className="readonly-grid">
//             <div className="form-group"><label>TICKET NUMBER</label><input type="text" value={ticketInfo.ticketNo} readOnly className="read-only-input" /></div>
//             <div className="form-group"><label>REQUEST DATE</label><input type="text" value={ticketInfo.date} readOnly className="read-only-input" /></div>
//             <div className="form-group"><label>EMPLOYEE NAME</label><input type="text" value={getEmployeeName()} readOnly className="read-only-input" /></div>
//             <div className="form-group"><label>EMAIL ADDRESS</label><input type="text" value={userData?.email || "Loading..."} readOnly className="read-only-input" /></div>
//           </div>

//           <div className="cyber-divider"></div>
//           <div className="form-sub-label">DEVICE_SPECIFICATIONS</div>
//           <div className="editable-grid">
//             <div className="form-group">
//               <label>SELECT DEVICE</label>
//               <div className="ui-select-container">
//                 <select value={device} onChange={(e)=>setDevice(e.target.value)} className="theme-select-field" required>
//                   <option value="" disabled hidden>Select hardware...</option>
//                   {deviceOptions.map(opt=><option key={opt} value={opt}>{opt}</option>)}
//                 </select>
//                 <span className="select-arrow">▼</span>
//               </div>
//             </div>
//             <div className="form-group"><label>MODEL NUMBER</label><input type="text" className="theme-text-input" value={modelNo} onChange={(e)=>setModelNo(e.target.value)} /></div>
//             <div className="form-group full-row"><label>DESCRIPTION OF ISSUE</label><textarea className="theme-textarea" value={description} onChange={(e)=>setDescription(e.target.value)} required /></div>
//             <div className="form-group">
//               <label>IMPACT OF WORK</label>
//               <div className="ui-select-container">
//                 <select value={impact} onChange={(e)=>setImpact(e.target.value)} className="theme-select-field" required>
//                   <option value="" disabled hidden>Choose urgency...</option>
//                   <option value="minor">Minor</option>
//                   <option value="major">Major</option>
//                   <option value="blocking">Blocking</option>
//                 </select>
//                 <span className="select-arrow">▼</span>
//               </div>
//             </div>
//           </div>

//           <div className="form-footer-actions">
//             <button type="submit" className="btn-submit-cyber" disabled={isSubmitting}>
//               {isSubmitting ? "PROCESSING..." : "GENERATE TICKET"}
//             </button>
//             <button type="button" className="btn-abort-cyber" onClick={()=>{setDevice(""); setDescription(""); setModelNo(""); setImpact(""); setSelectedImage(null);}}>CLEAR</button>
//           </div>
//         </form>

//         {/* Employee's own request history */}
//         <div className="request-history-section">
//           <div className="history-list">
//             {myRequests.map(req => (
//               <div key={req.id} className="history-item glass">
//                 <div className="history-info">
//                   <strong>{req.equipment_type}</strong>
//                   <span>Model: {req.model_no || 'N/A'}</span>
//                   <small>{new Date(req.updated_at).toLocaleDateString()}</small>
//                 </div>
//                 <div className={`status-badge badge-${req.status.toLowerCase()}`}>
//                   {req.status==='Approved'?' ':req.status==='Rejected'?' ':' '}
//                   {req.status.toUpperCase()}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>




//         {/* Management view */}
//         {isManagement && (
//           <div className="management-history-history-section" style={{marginTop:'50px'}}>
//             <div className="cyber-divider"></div>
//             <div className="form-sub-label" style={{color:'#888'}}>HISTORY</div>
//             <div className="admin-table-container">
//               <table className="cyber-table">
//                 <thead>
//                   <tr><th>EMPLOYEE</th><th>HARDWARE</th><th>DATE</th><th>STATUS</th></tr>
//                 </thead>
//                 <tbody>
//                   {allRequests.filter(r=>r.status?.toLowerCase()!=='pending').map(req => (
//                     <tr key={req.id}>
//                       <td>{req.employee_name}</td>
//                       <td>{req.equipment_type}</td>
//                       <td>{new Date(req.updated_at||req.created_at).toLocaleDateString('en-GB')}</td>
//                       <td>{req.status.toUpperCase()}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default EquipmentRequest;













import React, { useState, useEffect } from 'react';
import '../styles/EquipmentRequest.css';

const EquipmentRequest = ({ userData }) => {
  const [device, setDevice] = useState("");
  const [impact, setImpact] = useState("");
  const [modelNo, setModelNo] = useState("");
  const [description, setDescription] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [myRequests, setMyRequests] = useState([]);
  const [allRequests, setAllRequests] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isManagement = userData?.role === "management";
  const API_BASE = "/gt-api";

  const deviceOptions = [
    "Keyboard", "Mouse", "Monitor", "Headset", "Docking Station", "USB Cable", "Camera", "HDMI Cable", "Laptop"
  ];

  const ticketInfo = {
    ticketNo: "TCKT-2025-AX92",
    date: new Date().toLocaleDateString('en-GB'),
    assignedTo: "IT Support Team"
  };

  const getEmployeeName = () => {
    if (userData?.firstName || userData?.lastName) {
      return `${userData.firstName || ''} ${userData.lastName || ''}`.trim();
    }
    return userData?.fullName || "Loading...";
  };

  const fetchHistory = () => {
    const empId = userData?.id;

    fetch(`${API_BASE}/get_user_requests.php?employee_id=${empId}`, {
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) setMyRequests(data.requests);
      })
      .catch(err => console.error("Error fetching history:", err));
  };

  const fetchAllRequests = () => {
    fetch(`${API_BASE}/get_all_equip_request.php`, {
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => { if (data.success) setAllRequests(data.requests); })
      .catch(err => console.error("Error fetching management history:", err));
  };

  const clearNotifications = async () => {
    const empId = userData?.id;

    try {
      await fetch(`${API_BASE}/clear_notifications.php`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ employee_id: empId }),
      });
    } catch (err) {
      console.error("Failed to clear notifications:", err);
    }
  };
  useEffect(() => {
    if (!userData) return;
    if (isManagement) fetchAllRequests();
    else { fetchHistory(); clearNotifications(); }
  }, [userData]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setSelectedImage(reader.result);
      reader.readAsDataURL(file);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const formData = new FormData();

      formData.append(
        'employee_id',
        userData?.id
      );
      formData.append(
        'employee_name',
        getEmployeeName()
      );
      formData.append(
        'equipment_type',
        device
      );
      formData.append(
        'reason',
        description
      );
      formData.append(
        'model_no',
        modelNo
      );
      formData.append(
        'impact',
        impact
      );

      const fileInput = document.getElementById('equip-file-upload');

      if (fileInput?.files[0]) {
        formData.append('image', fileInput.files[0]);
      }
      const response = await fetch(
        `${API_BASE}/submit_equipment_request.php`,
        {
          method: "POST",
          credentials: "include",
          body: formData,
        }
      );

      const text = await response.text();
      console.log("Raw response from PHP:", text);

      let data;

      try {
        data = JSON.parse(text);
      } catch (err) {
        throw new Error("Invalid JSON response from server");
      }

      if (data.success) {
        alert(`Ticket submitted successfully!`);

        setDevice("");
        setDescription("");
        setModelNo("");
        setImpact("");
        setSelectedImage(null);

        if (fileInput) {
          fileInput.value = "";
        }

        // Refresh employee's history immediately
        fetchHistory();

        // Refresh management table if applicable
        if (isManagement) {
          fetchAllRequests();
        }

      } else {
        alert("Submission failed: " + data.message);
      }

    } catch (error) {
      console.error("Error submitting ticket:", error);
      alert("Server error. Please check console for details.");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div className="equipment-request-wrapper animate-fade">
      <div className="request-card glass">
        <div className="form-header-main">
          <div className="header-icon">⚙️</div>
          <div className="header-titles"><h2>EQUIPMENT_CHECK_REQUEST</h2></div>
        </div>

        <form className="cyber-form-layout" onSubmit={handleSubmit}>
          <div className="form-sub-label">IDENTIFICATION_METADATA</div>
          <div className="readonly-grid">
            <div className="form-group"><label>TICKET NUMBER</label><input type="text" value={ticketInfo.ticketNo} readOnly className="read-only-input" /></div>
            <div className="form-group"><label>REQUEST DATE</label><input type="text" value={ticketInfo.date} readOnly className="read-only-input" /></div>
            <div className="form-group"><label>EMPLOYEE NAME</label><input type="text" value={getEmployeeName()} readOnly className="read-only-input" /></div>
            <div className="form-group"><label>EMAIL ADDRESS</label><input type="text" value={userData?.email || "Loading..."} readOnly className="read-only-input" /></div>
          </div>

          <div className="cyber-divider"></div>
          <div className="form-sub-label">DEVICE_SPECIFICATIONS</div>
          <div className="editable-grid">
            <div className="form-group">
              <label>SELECT DEVICE</label>
              <div className="ui-select-container">
                <select value={device} onChange={(e) => setDevice(e.target.value)} className="theme-select-field" required>
                  <option value="" disabled hidden>Select hardware...</option>
                  {deviceOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                </select>
                <span className="select-arrow">▼</span>
              </div>
            </div>
            <div className="form-group"><label>MODEL NUMBER</label><input type="text" className="theme-text-input" value={modelNo} onChange={(e) => setModelNo(e.target.value)} /></div>
            <div className="form-group full-row"><label>DESCRIPTION OF ISSUE</label><textarea className="theme-textarea" value={description} onChange={(e) => setDescription(e.target.value)} required /></div>
            <div className="form-group">
              <label>IMPACT OF WORK</label>
              <div className="ui-select-container">
                <select value={impact} onChange={(e) => setImpact(e.target.value)} className="theme-select-field" required>
                  <option value="" disabled hidden>Choose urgency...</option>
                  <option value="minor">Minor</option>
                  <option value="major">Major</option>
                  <option value="blocking">Blocking</option>
                </select>
                <span className="select-arrow">▼</span>
              </div>
            </div>
          </div>

         <div className="form-footer-actions equipment-actions">
            <button type="submit" className="btn-submit-cyber" disabled={isSubmitting}>
              {isSubmitting ? "PROCESSING..." : "GENERATE TICKET"}
            </button>
            <button type="button" className="btn-abort-cyber" onClick={() => { setDevice(""); setDescription(""); setModelNo(""); setImpact(""); setSelectedImage(null); }}>CLEAR</button>
          </div>
        </form>

        {/* Employee's own request history */}
        <div className="request-history-section">
          <div className="history-list">
            {myRequests.map(req => (
              <div key={req.id} className="history-item glass">
                <div className="history-info">
                  <strong>{req.equipment_type}</strong>
                  <span>Model: {req.model_no || 'N/A'}</span>
                  <small>{new Date(req.updated_at).toLocaleDateString()}</small>
                </div>
                <div className={`status-badge badge-${req.status.toLowerCase()}`}>
                  {req.status === 'Approved' ? ' ' : req.status === 'Rejected' ? ' ' : ' '}
                  {req.status.toUpperCase()}
                </div>
              </div>
            ))}
          </div>
        </div>




        {/* Management view */}
        {isManagement && (
          <div className="management-history-history-section" style={{ marginTop: '50px' }}>
            <div className="cyber-divider"></div>
            <div className="form-sub-label" style={{ color: '#888' }}>HISTORY</div>
            <div className="admin-table-container">
              <div className="history-table-wrapper">
                <table className="cyber-table">
                  <thead>
                    <tr>
                      <th>EMPLOYEE</th>
                      <th>HARDWARE</th>
                      <th>DATE</th>
                      <th>STATUS</th>
                    </tr>
                  </thead>

                  <tbody>
                    {allRequests
                      .filter(r => r.status?.toLowerCase() !== 'pending')
                      .map(req => (
                        <tr key={req.id}>
                          <td>{req.employee_name}</td>
                          <td>{req.equipment_type}</td>
                          <td>
                            {new Date(
                              req.updated_at || req.created_at
                            ).toLocaleDateString("en-GB")}
                          </td>
                          <td>
                            <span
                              className={`status-pill ${req.status.toLowerCase()
                                }`}
                            >
                              {req.status.toUpperCase()}
                            </span>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EquipmentRequest;

